import { colors } from '@alixpartners/ui-components';

export const NotificationTypes = {
	success: 'success',
	warning: 'warning',
	danger: 'danger',
	simple: 'simple',
};

export const NotificationColors = {
	success: '#4caf50',
	warning: '#ff9800',
	danger: '#f44336',
	simple: `${colors.blue400}`,
};
